module.exports = __webpack_public_path__ + "static/img/training_system_s3_max3.0dbc230c.png";